export default {
  // Save function
  SAVE_SUCCESS: 'บันทึกสำเร็จ',
  DELETE_SUCCESS: 'ลบสำเร็จ',
  EDIT_SUCCESS: 'แก้ไขสำเร็จ',
  SET_IS_ERROR: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',

  // ConfirmWidget
  CONFIRM_SAVE_TITLE: 'ยืนยันการบันทึก',
  CONFIRM_SAVE_DETAIL: '',
  // CONFIRM_SAVE_DETAIL: 'ยืนยันการบันทึก',

  CONFIRM_DELETE_DOC_TITLE: 'ยืนยันลบเอกสาร',
  CONFIRM_DELETE_DOC_DETAIL: '',
  // CONFIRM_DELETE_DOC_DETAIL: 'ยืนยันลบเอกสาร',

  WARN_SELECTED_ITEM_TITLE: 'แจ้งเตือน',
  WARN_SELECTED_ITEM_DETAIL: 'ไม่สามารขอขึ้นทะเบียนได้ กรุณาเลือกครุภัณฑ์อย่างน้อย 1 รายการ',
  WARN_SELECTED_ITEM_DETAIL_APPROVE: 'ไม่สามารถส่งพิจารณา กรุณาเลือกครุภัณฑ์อย่างน้อย 1 รายการ',
  WARN_SELECTED_ITEM_AUDIT: 'ไม่สามารถแจ้งผลตรวจสอบได้ กรุณาเลือกอย่างน้อย 1 รายการ',

  MSG_TABLE_LENGTH_OF_ZERO: 'กรุณาเพิ่มรายการ อย่างน้อย 1 รายการ',
}
